var map = {
	"./Bianco.png": 1207,
	"./Fermo.png": 1208,
	"./Passito.png": 1209,
	"./Rosato.png": 1210,
	"./Rosso.png": 1211,
	"./Spumante.png": 1212
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 219;